import { render } from "./News.vue?vue&type=template&id=cf0f30dc"
const script = {}
script.render = render

export default script